import React, { useEffect } from 'react';
import Title from '../Components/Title';
import ContactItem from '../Components/ContactItem';
import ContactForm from '../Components/ContactForm';
import PhoneIcon from '@material-ui/icons/Phone';
import EmailIcon from '@material-ui/icons/Email';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import { MainLayout, } from '../Styles/mainLayouts';
import styles from '../Styles/hoverText.module.css'
import styled from 'styled-components';
import AOS from 'aos';
import 'aos/dist/aos.css';

const ContactPageStyled = styled.section`
        width:98%;
        padding: 5rem 0;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-column-gap: 2rem;
        @media screen and (max-width: 978px){
            grid-template-columns: repeat(1, 1fr);
            .f-button{
                margin-bottom: 3rem;
            }
        }
        @media screen and (max-width: 600px){
            overflow: hidden;
        }
        
        .right-content{
            display: flex;
            gap: 1rem;
            flex-direction: column;
        }
        .left-content{
            padding-bottom:1rem;
        }
`;

const ContactPage = () => {
    useEffect(() => {
        AOS.init({ duration: 2000, })
    }, [])

    return (
        <div id="ContactPage">
            <MainLayout>
                <Title title={'Contact'} />
                <ContactPageStyled>
                    <div className="left-content" data-aos="fade-right">
                        <ContactForm />
                    </div>
                    <div className="right-content" data-aos="fade-left">
                        <ContactItem title={'Phone'} icon={
                            <p className={styles.tooltip}><a href="tel:+917355725662"><PhoneIcon /></a>
                                <span className={styles.tooltipText}>click to make call</span>
                            </p>} cont={'+917355725662'} />
                        <ContactItem title={'Email'} icon={
                            <p className={styles.tooltip} style={{ paddingBottom: "1px" }}><a href="https://mail.google.com/mail/u/0/?tab=rm&ogbl#inbox" target="_blank" rel="noopener noreferrer"><EmailIcon /></a>
                                <span className={styles.tooltipText}>click to send mail</span>
                            </p>} cont={'ahsanbeg738@gmail.com'} />
                        <ContactItem title={'Address'} icon={<LocationOnIcon />} cont={'Khudaganj, Uttar Pradesh'} />
                    </div>
                </ContactPageStyled>
            </MainLayout>
        </div>
    )
}
export default ContactPage